
import { WDFormBasic } from './wd-form-basic';
import WDDropdownForm from '../dropdown/wd-dropdown-form';
import WDDropdownMultiForm from '../dropdown/wd-dropdown-multi-form';
import WDDropdownFormObject from '../dropdown/wd-dropdown-object-form';
import WDDropdownFormObjectMulti from '../dropdown/wd-dropdown-object-multi-form';

export class WDFormDropdown extends WDFormBasic {

	#dropdown = null;
				
	constructor(opts)
	{
	  let dd;

    //adapt to the dropdown type if passed	  
	  if (opts?.dropdown_type == 'multi') dd = new WDDropdownMultiForm(opts);
	  else if (opts?.dropdown_type == 'object') dd = new WDDropdownFormObject(opts);
	  else if (opts?.dropdown_type == 'multiobject') dd = new WDDropdownFormObjectMulti(opts);
	  else dd = new WDDropdownForm(opts);

		super(dd,opts);

		this.#dropdown = dd;
    this.#dropdown.on('change',(evt) => this.trigger('change',evt) );
    this.#dropdown.on('input',(evt) => this.trigger('input',evt) );
    this.#dropdown.on('value:set',(evt) => this.trigger('value:set',evt) );
    this.#dropdown.on('options:set',(evt) => this.trigger('options:set',evt) );
    this.#dropdown.on('options:updated',(evt) => this.trigger('options:updated',evt) );

    if (opts?.required)
    {
      this.#dropdown.on('input',() => {
        const f = this.closest('wd-form-proxy');
        if (f && f.classList.contains('was-validated')) this.validate();
      });
    }
	};

	get options() { return this.#dropdown.options(); };
  set options(newOptions) { return this.#dropdown.options = newOptions; };
  get fetch() { return this.#dropdown.fetch; };
  set fetch(f) { this.#dropdown.fetch = f; };
  set fetchURI(uri) { return this.#dropdown.fetchURI = uri; };
  get fetchOptions() { return this.#dropdown.fetchOptions; };
  	
  get value() { return this.#dropdown.value; };
  set value(val) { this.#dropdown.value = val; };

  set valueLabel(lbls) { this.#dropdown.valueLabel = lbls; };

  get readonly() { return this.#dropdown.readonly; };
  set readonly(val) { this.#dropdown.readonly = val; };
	
  /**
    */
  validate()
  {
    let ret = true;

    //if set to not allow nulls   
    if (!this.classList.contains('is-hidden') && this.config.required == true && this.value == null)
    {
      ret = false;
      this.markError(true);
    }
    else 
    {
      ret = true;
      this.markSuccess(true);
    }
    return ret;
  };

};

customElements.define('wd-form-dropdown',WDFormDropdown);
